// extracted by mini-css-extract-plugin
module.exports = {"center_horizontal":"center_horizontal--ItemListView-components__IZTM5","centerHorizontal":"center_horizontal--ItemListView-components__IZTM5"};